<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['team-members-head-title']"
    :description="propsdata[0]['translation']['team-members-head-description']"
/>

    <div v-if="loading" style="margin-top: 150px;">
      <lottie-player src="https://qr.io/lottie/qr-loading.json" background="transparent" speed="1" style="width: 230px; height: 230px; margin: 0 auto;" loop autoplay></lottie-player>
    </div>

    <div v-if="!loading" class="container mb-3">
      <div class="card border-light shadow-soft rounded-top-0 rounded-bottom">
        <div class="card-body p-4">
          <div>
            <div v-if="propsdata[0].paid === 'yes'" class="col-12 p-0">
              <div>
                <label class="form-label text-dark">{{propsdata[0]['translation']['team-members-title']}}</label>
                <p>{{propsdata[0]['translation']['team-members-description-1']}}<br><strong>{{propsdata[0]['translation']['team-members-note']}}</strong> {{propsdata[0]['translation']['team-members-the-note']}}</p>
                <p><strong>{{propsdata[0]['translation']['team-members-limited-access']}}</strong> {{propsdata[0]['translation']['team-members-limited-access-description']}} <br><strong>{{propsdata[0]['translation']['team-members-advanced-access']}}</strong> {{propsdata[0]['translation']['team-members-advanced-access-description']}}</p>
                <div>
                  <div v-for="(team_member, index) in team_members" class="d-md-flex justify-content-between align-items-center mb-3" style="gap: 10px;">
                    <!-- team members -->
                    <div class="col p-0 mb-3 mb-md-0">
                      <label class="my-1 mr-2">{{propsdata[0]['translation']['team-members-email']}}</label>
                      <input v-model="team_member.email" type="email" name="email" class="form-control" placeholder="john@example.com" disabled="disabled">
                    </div>
                    <div class="col p-0 mb-3 mb-md-0">
                      <label class="my-1 mr-2" for="select-team-member-access1">{{propsdata[0]['translation']['team-members-access']}}</label>
                      <select v-model="team_member.access_limit" class="custom-select" id="select-team-member-access1" :class='{"editandowebsite": team_member.edit}' :disabled="!team_member.edit">
                        <option value="limited">{{propsdata[0]['translation']['team-members-limited']}}</option>
                        <option value="advanced">{{propsdata[0]['translation']['team-members-advanced']}}</option>
                      </select>
                    </div>
                    <!-- edit and delete buttons -->
                    <div v-if="propsdata[0].team_member !== 'yes'">
                      <div v-if="!team_member.edit" class="text-center mb-3 mb-md-0 pt-md-4">
                        <!-- button edit -->
                        <button @click="edit_team_member(index)" class="btn btn-secondary px-3">
                          <i class="fas fa-pen"></i>
                        </button>
                        <!-- button delete -->
                        <button @click="open_modal_delete_team_member(index)" class="btn btn-danger px-3">
                          <i class="far fa-trash-alt"></i>
                        </button>
                      </div>
                      <div v-if="team_member.edit" class="text-center mb-3 mb-md-0 pt-md-4">
                        <!-- button save edit -->
                        <button @click="save_edited_team_member(index)" class="btn btn-success px-3">
                          {{propsdata[0]['translation']['team-members-save-changes-edit']}}
                          <i class="fas fa-check"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="(team_members === null || team_members.length === 0) && !new_team_member_section" style="text-align:center;">
                    <h5 style="margin-bottom: 1rem;">{{propsdata[0]['translation']['team-members-no-team-members-added']}}</h5>
                  </div>
                  <div v-if="(team_members === null || team_members.length < 5) && !new_team_member_section && propsdata[0].team_member !== 'yes'" class="mb-4">
                    <button @click="add_new_team_member" class="btn btn-secondary animate-up-2" style="width: 100%;"><span class="mr-1"><span class="fas fa-plus"></span></span> {{propsdata[0]['translation']['team-members-add']}}</button>
                  </div>
                  <!-- add -->
                  <div v-if="new_team_member_section && propsdata[0].team_member !== 'yes'">
                    <div class="d-md-flex justify-content-between align-items-center mb-3" style="gap: 10px;">
                      <div class="col p-0 mb-3 mb-md-0">
                        <label class="my-1 mr-2">{{propsdata[0]['translation']['team-members-email']}}</label>
                        <input v-model="team_member_email" type="email" name="email" class="form-control" placeholder="john@example.com">
                        <p v-if="errorwhileaddingteammember" class="text-danger mt-2 mb-0">{{propsdata[0]['translation']['team-members-error-while-adding-team-member']}}</p>
                        <p v-if="errorwhileaddingteammember" class="text-danger mt-2 mb-0">{{propsdata[0]['translation']['team-members-error-while-adding-team-member']}}</p>
                        <p v-if="usernotfound" class="text-danger mt-2 mb-0">{{propsdata[0]['translation']['team-members-user-not-found']}}</p>
                        <p v-if="maxteammembers" class="text-danger mt-2 mb-0">{{propsdata[0]['translation']['team-members-max-team-members-added']}}</p>
                        <p v-if="teammemberscannotaddnewteammembers" class="text-danger mt-2 mb-0">{{propsdata[0]['translation']['team-members-team-members-cannot-add-new-team-members']}}</p>
                        <p v-if="invalidemail" class="text-danger mt-2 mb-0">{{propsdata[0]['translation']['team-members-invalid-email']}}</p>
                        <p v-if="emailtaken" class="text-danger mt-2 mb-0">{{propsdata[0]['translation']['team-members-taken-email']}}</p>
                      </div>
                      <div class="col p-0 mb-3 mb-md-0">
                        <label class="my-1 mr-2" for="select-team-member-access2">{{propsdata[0]['translation']['team-members-access']}}</label>
                        <select v-model="team_member_access" class="custom-select" id="select-team-member-access2">
                          <option value="limited">{{propsdata[0]['translation']['team-members-limited']}}</option>
                          <option value="advanced">{{propsdata[0]['translation']['team-members-advanced']}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div v-if="new_team_member_section && propsdata[0].team_member !== 'yes'" class="mb-4">
                    <button v-if="!saving_new_team_member" @click="save_new_team_member" class="btn btn-primary animate-up-2 mb-2" style="width: 100%;"><span class="mr-1"><span class="fas fa-check"></span></span> {{propsdata[0]['translation']['team-members-add-team-member']}}</button>
                    <button v-if="saving_new_team_member" class="btn btn-primary animate-up-2 mb-2" style="width: 100%;"><span class="mr-1"><span class="fas fa-check"></span></span> {{propsdata[0]['translation']['team-members-adding']}}</button>
                    <button @click="cancel_new_team_member" class="btn btn-danger animate-up-2" style="width: 100%;"><span class="mr-1"><span class="fas fa-times"></span></span> {{propsdata[0]['translation']['team-members-cancel']}}</button>
                  </div>
                  <div v-if="propsdata[0].team_member === 'yes'" class="alert alert-warning mb-0" role="alert">
                    <span class="alert-inner--text">{{propsdata[0]['translation']['team-members-access-limit-warning']}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="col-12 p-0">
              <h4 class="mb-0">{{propsdata[0]['translation']['team-members-upgrade']}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Team Member Modal Content -->
      <div v-if="modal_delete_team_member" @click="close_modal_delete_team_member" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
        <div @click.stop class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header w-100">
              <p class="lead mb-0">{{propsdata[0]['translation']['team-members-delete-modal-title']}}</p>
              <button @click="close_modal_delete_team_member" class="close ml-auto" style="position: absolute; right: 21px;">
                <span>×</span>
              </button>
            </div>
            <div class="modal-body">
              <p class="mb-0">{{propsdata[0]['translation']['team-members-delete-modal-description']}}</p>
              <p v-if="errorwhiledeletingteammember" class="text-danger mt-2 mb-0">{{propsdata[0]['translation']['team-members-error-while-deleting-team-member']}}</p>
            </div>
            <div class="modal-footer">
              <button v-if="!deletingteammember" @click="close_modal_delete_team_member" class="ml-sm-1 btn btn-light mr-auto">{{propsdata[0]['translation']['team-members-delete-modal-no']}}</button>
              <button v-if="!deletingteammember" @click="delete_team_member" class="ml-sm-1 btn btn-danger">{{propsdata[0]['translation']['team-members-delete-modal-yes']}}</button>
              <button v-if="deletingteammember" class="ml-sm-1 btn btn-danger">{{propsdata[0]['translation']['team-members-delete-modal-deleting']}}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- End of Delete Team Member Modal Content -->

    </div>
  </div>
</template>

<style>
  .editandowebsite {
    background-color: #f9fafb;
    border-color: #1e90ff5e;
    outline: 0;
    box-shadow: inset 0 1px 2px rgb(46 54 80 / 8%), 0 0 0 0.2rem rgb(38 43 64 / 20%);
  }
</style>

<script>
  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        team_members: [],
        team_member_email: '',
        team_member_access: 'limited',
        new_team_member_section: false,
        saving_new_team_member: false,
        errorwhileaddingteammember: false,
        usernotfound: false,
        maxteammembers: false,
        teammemberscannotaddnewteammembers: false,
        emailtaken: false,
        invalidemail: false,
        modal_delete_team_member: false,
        id_a_eliminar: '',
        deletingteammember: false,
        errorwhiledeletingteammember: false
      };
    },
    methods: {
      add_new_team_member() {
        this.new_team_member_section = true;
      },
      save_new_team_member() {
        this.saving_new_team_member = true;
        this.emailtaken = false;
        this.invalidemail = false;
        axios.post('/dashboard/save-team-members.php', {
          email: this.team_member_email,
          access_limit: this.team_member_access
        })
        .then(response => {
          if(response.data == 'There was an error while saving the team member'){
            this.errorwhileaddingteammember = true;
          }
          else if(response.data == 'User not found'){
            this.usernotfound = true;
          }
          else if(response.data == 'Already 5 team members added'){
            this.maxteammembers = true;
          }
          else if(response.data == 'Team members cannot add new team members'){
            this.teammemberscannotaddnewteammembers = true;
          }
          else if(response.data == 'invalid email'){
            this.invalidemail = true;
          }
          else if(response.data == 'email already registered'){
            this.emailtaken = true;
          }
          else{
            if(this.team_members === null || this.team_members.length === 0){
              this.team_members = [];
              this.team_members.push(response.data);
            }
            else{
              this.team_members.push(response.data);
            }
            this.new_team_member_section = false;
            this.saving_new_team_member = false;
            this.team_member_email = '';
            this.team_member_access = 'limited';
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      edit_team_member(index) {
        this.team_members[index]['edit'] = true;
      },
      cancel_new_team_member() {
        this.new_team_member_section = false;
      },
      save_edited_team_member(index) {
        this.team_members[index]['edit'] = false;
        // Save changes
        axios.post('/dashboard/edit-team-members.php', {
          userid: this.team_members[index]['userid'],
          access_limit: this.team_members[index]['access_limit']
        })
      },
      open_modal_delete_team_member(index){
        this.id_a_eliminar = index;
        this.modal_delete_team_member = true;
      },
      close_modal_delete_team_member(){
        this.modal_delete_team_member = false;
      },
      delete_team_member() {
        this.deletingteammember = true;
        this.errorwhiledeletingteammember = false;
        var id_a_eliminar = this.team_members[this.id_a_eliminar]['userid'];
        var email_a_eliminar = this.team_members[this.id_a_eliminar]['email'];
        //
        axios.post('/dashboard/delete-team-members.php', {
          userid: id_a_eliminar,
          email: email_a_eliminar
        })
        .then(response => {
          if(response.data == 'There was an error while deleting the team member'){
            this.errorwhiledeletingteammember = true;
          }
          else{
            this.team_members.splice(this.id_a_eliminar, 1);
            this.modal_delete_team_member = false;
          }
          this.deletingteammember = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    mounted() {
      //TEAM MEMBERS
      axios.post('/dashboard/cargar-team-members.php', {
      })
      .then(response => {
        this.team_members = response.data;
        if(response.data === null){
          this.team_members = [];
        }
        this.loading = false;
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  };
  </script>



// WEBPACK FOOTER //
// src/team-members.vue